import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from "./ui/button";
import { translations } from '../data/translations';

const slides = [
  {
    type: 'video',
    src: "https://customer-assets.emergentagent.com/job_grill-masters-58/artifacts/tsjwbpqz_0%20Grill%20Meat%201280X720%20LOW.mp4",
    duration: 10000
  },
  {
    type: 'image',
    src: "https://images.unsplash.com/photo-1613628068926-0a5562f4aa9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxzdGVhayUyMGdyaWxsfGVufDB8fHx8MTc3MDEzOTY0M3ww&ixlib=rb-4.1.0&q=85",
    duration: 5000
  },
  {
    type: 'image',
    src: "https://images.unsplash.com/photo-1593504049359-74330189a345?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxnb3VybWV0JTIwcGl6emF8ZW58MHx8fHwxNzcwMDkzOTAwfDA&ixlib=rb-4.1.0&q=85",
    duration: 5000
  },
  {
    type: 'image',
    src: "https://images.unsplash.com/photo-1761095596559-a99659d772dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxtaXhlZCUyMGdyaWxsfGVufDB8fHx8MTc3MDEzOTY2NHww&ixlib=rb-4.1.0&q=85",
    duration: 5000
  }
];

export const HeroSlider = ({ lang }) => {
  const [current, setCurrent] = useState(0);
  const t = translations[lang].hero;

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, slides[current].duration);
    return () => clearTimeout(timer);
  }, [current]);

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden bg-black">
      <AnimatePresence mode="wait">
        <motion.div
          key={current}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.5 }}
          className="absolute inset-0 w-full h-full"
        >
          {slides[current].type === 'video' ? (
            <div className="relative w-full h-full">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="absolute inset-0 w-full h-full object-cover"
              >
                <source src={slides[current].src} type="video/mp4" />
              </video>
              {/* Dark Overlay for Video */}
              <div className="absolute inset-0 bg-black/60" />
            </div>
          ) : (
            <div className="relative w-full h-full">
              <div 
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${slides[current].src})` }}
              />
               {/* Dark Overlay for Images */}
               <div className="absolute inset-0 bg-black/50" />
            </div>
          )}
          {/* Global Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent pointer-events-none" />
        </motion.div>
      </AnimatePresence>

      <div className="absolute inset-0 flex items-center z-10">
        <div className="container mx-auto px-4 md:px-6 pt-20">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="max-w-2xl text-white space-y-6"
          >
            <div className="inline-block bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full mb-2 uppercase tracking-widest">
              Est. 2024
            </div>
            <h1 className="text-5xl md:text-7xl font-bold leading-tight tracking-tight drop-shadow-lg">
              BUFFALO <br />
              <span className="text-red-500">GRILL HOUSE</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-200 leading-relaxed font-light border-l-4 border-red-600 pl-4 drop-shadow-md">
              {t.subtitle}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button 
                size="lg" 
                className="bg-red-600 hover:bg-red-700 text-white border-0 font-bold tracking-wide h-14 px-8 text-md rounded-none skew-x-[-10deg] hover:skew-x-0 transition-all shadow-lg"
                onClick={() => window.open('https://www.restaurantlogin.com/api/fb/y_pz_z_x', '_blank')}
              >
                <span className="skew-x-[10deg] hover:skew-x-0 inline-block">{t.cta_order}</span>
              </Button>
              <Button 
                size="lg" 
                variant="outline"
                className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-black font-bold tracking-wide h-14 px-8 text-md rounded-none skew-x-[-10deg] hover:skew-x-0 transition-all shadow-lg"
                onClick={() => window.open('https://www.restaurantlogin.com/api/res/y_pz_z_x', '_blank')}
              >
                  <span className="skew-x-[10deg] hover:skew-x-0 inline-block">{t.cta_book}</span>
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
